import { createContext, useContext, useState } from 'react'

import Slider from 'react-slick'

import Modal from '../components/Modal/Modal'
import { NextArrow, PrevArrow } from '../components/Slider/Arrows'

import './gallery.scss'

// https://github.com/akiran/react-slick
const slickSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
}

const GalleryContext = createContext(null)

export const GalleryContextProvider = ({ children }) => {
  const [state, dispatch] = useState({
    isOpen: false,
    images: [],
  })

  const { isOpen, images } = state

  const openGallery = (images) => {
    dispatch({
      isOpen: true,
      images,
    })
  }

  const closeGallery = () => {
    dispatch({
      isOpen: false,
      images: [],
    })
  }

  return (
    <GalleryContext.Provider
      value={{
        openGallery,
      }}
    >
      <>
        {children}
        {isOpen && (
          <Modal
            isOpen={isOpen}
            onRequestClose={closeGallery}
            contentClassName="gallery-modal"
          >
            <Slider {...slickSettings}>
              {images.map((image) => (
                <img key={image.src} src={image.src} alt={image.alt} />
              ))}
            </Slider>
          </Modal>
        )}
      </>
    </GalleryContext.Provider>
  )
}
const useGallery = () => useContext(GalleryContext)
export default useGallery
